class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      this.slideShow();
      this.insertState();
      qs(".download_quotation") && this.downloadQuotation();
      qs(".free-shipping") && this.updateFreeShipping();
      this.validateButton();
      this.getPdf();
      if (qs('.unable-to-click')) {
        qs(".cart-count-bubble") ? qs('.unable-to-click').classList.add('hide') : qs('.unable-to-click').classList.remove('hide');
        setTimeout(() => {
          let cartCountElem = qs('.cart-count');
          let cartContainer = qs('.realtive_li.cart');

          if (cartContainer) {
            if (cartCountElem) {
              let count = cartCountElem.textContent.replace(')', '').replace('(', '');
              cartContainer.innerHTML = `
              <a class="icons-links" id="cart-icon-bubble" role="button" aria-haspopup="dialog">
                <svg class="icon icon-cart" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                  <path fill="currentColor" fill-rule="evenodd" d="m15.84,10.8l1.28-4.56H5.26l1.28,4.56c.08.29.25.54.48.71.22.17.51.27.81.27h6.73c.31,0,.59-.1.81-.27.22-.17.39-.41.48-.71h0Zm-1.29,2.57c.42,0,.8.17,1.08.45.28.28.45.66.45,1.08s-.17.8-.45,1.08c-.28.28-.66.45-1.08.45s-.8-.17-1.08-.45c-.28-.28-.45-.66-.45-1.08s.17-.8.45-1.08c.28-.28.66-.45,1.08-.45Zm.51,1.02c-.13-.13-.31-.21-.51-.21s-.38.08-.51.21c-.13.13-.21.31-.21.51s.08.38.21.51c.13.13.31.21.51.21s.38-.08.51-.21c.13-.13.21-.31.21-.51s-.08-.38-.21-.51Zm-7.24-1.02c.42,0,.8.17,1.08.45.28.28.45.66.45,1.08s-.17.8-.45,1.08c-.28.28-.66.45-1.08.45s-.8-.17-1.08-.45c-.28-.28-.45-.66-.45-1.08s.17-.8.45-1.08c.28-.28.66-.45,1.08-.45Zm.51,1.02c-.13-.13-.31-.21-.51-.21s-.38.08-.51.21c-.13.13-.21.31-.21.51s.08.38.21.51c.13.13.31.21.51.21s.38-.08.51-.21c.13-.13.21-.31.21-.51s-.08-.38-.21-.51ZM4.33,5.92l-.2-.73c-.08-.29-.25-.54-.48-.71-.22-.17-.51-.27-.81-.27h-1.31c-.22,0-.4-.18-.4-.4s.18-.4.4-.4h1.31c.49,0,.93.16,1.3.43.36.27.63.67.77,1.13l.13.46h12.62s.07,0,.11.02c.21.06.34.28.28.5l-1.42,5.07c-.13.47-.4.86-.77,1.13-.36.27-.81.43-1.3.43h-6.73c-.49,0-.93-.16-1.3-.43-.36-.27-.63-.66-.77-1.13l-1.42-5.04s-.01-.03-.01-.05h0Z"></path>
                </svg>
                <span class="visually-hidden">Cart</span>
                <p class="cart-count-bubble">
                  <span aria-hidden="true">${count}</span>
                  <span class="visually-hidden">${count} item</span>
                </p>
              </a>
              <p class="icon_para">CART</p>
            `;
            } else {
              cartContainer.innerHTML = `
              <a class="icons-links" id="cart-icon-bubble" role="button" aria-haspopup="dialog">
                <svg class="icon icon-cart" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                  <path fill="currentColor" fill-rule="evenodd" d="m15.84,10.8l1.28-4.56H5.26l1.28,4.56c.08.29.25.54.48.71.22.17.51.27.81.27h6.73c.31,0,.59-.1.81-.27.22-.17.39-.41.48-.71h0Zm-1.29,2.57c.42,0,.8.17,1.08.45.28.28.45.66.45,1.08s-.17.8-.45,1.08c-.28.28-.66.45-1.08.45s-.8-.17-1.08-.45c-.28-.28-.45-.66-.45-1.08s.17-.8.45-1.08c.28-.28.66-.45,1.08-.45Zm.51,1.02c-.13-.13-.31-.21-.51-.21s-.38.08-.51.21c-.13.13-.21.31-.21.51s.08.38.21.51c.13.13.31.21.51.21s.38-.08.51-.21c.13-.13.21-.31.21-.51s-.08-.38-.21-.51Zm-7.24-1.02c.42,0,.8.17,1.08.45.28.28.45.66.45,1.08s-.17.8-.45,1.08c-.28.28-.66.45-1.08.45s-.8-.17-1.08-.45c-.28-.28-.45-.66-.45-1.08s.17-.8.45-1.08c.28-.28.66-.45,1.08-.45Zm.51,1.02c-.13-.13-.31-.21-.51-.21s-.38.08-.51.21c-.13.13-.21.31-.21.51s.08.38.21.51c.13.13.31.21.51.21s.38-.08.51-.21c.13-.13.21-.31.21-.51s-.08-.38-.21-.51ZM4.33,5.92l-.2-.73c-.08-.29-.25-.54-.48-.71-.22-.17-.51-.27-.81-.27h-1.31c-.22,0-.4-.18-.4-.4s.18-.4.4-.4h1.31c.49,0,.93.16,1.3.43.36.27.63.67.77,1.13l.13.46h12.62s.07,0,.11.02c.21.06.34.28.28.5l-1.42,5.07c-.13.47-.4.86-.77,1.13-.36.27-.81.43-1.3.43h-6.73c-.49,0-.93-.16-1.3-.43-.36-.27-.63-.66-.77-1.13l-1.42-5.04s-.01-.03-.01-.05h0Z"></path>
                </svg>
                <span class="visually-hidden">Cart</span>
              </a>
              <p class="icon_para">CART</p>
            `;
            }
          }
        }, 1000);
      }
    });
  }

  downloadQuotation = () => {

  const toggleQuotation = () => {
    qs(".shoping-cart-form-body")?.classList.toggle("hide");
    qs(".shoping-cart-form-body")?.classList.toggle("overflow-hidden");

    qs(".head-quote")?.classList.toggle("hide");
    qs(".gst-field")?.classList.toggle("hide");
    qs(".delivery-canvas-screen")?.classList.toggle("hide");
    qs(".quotation")?.classList.toggle("hide");
    qs(".free-shipping")?.classList.toggle("hide");
    qs("cart-drawer-items")?.classList.toggle("hide");
    qs(".cart-with-footer")?.classList.toggle("hide");
    qs(".delivery-canvas-header-parent")?.classList.toggle("hide");

    document.body.classList.toggle("overflow-hidden");
  };

  const downloadBtn = qs(".download_quotation");
  const backBtn = qs(".show-shoping-screen");

  if (downloadBtn && !downloadBtn.dataset.listenerAdded) {
    downloadBtn.dataset.listenerAdded = "true";

    downloadBtn.addEventListener("click", (e) => {
      e.preventDefault();
      toggleQuotation();
    });
  }

  if (backBtn && !backBtn.dataset.listenerAdded) {
    backBtn.dataset.listenerAdded = "true";

    backBtn.addEventListener("click", (e) => {
      e.preventDefault();
      toggleQuotation();
    });
  }
};

  validateButton = () => {
    $('#download_book_Service1').prop('disabled', true);

    const validateForm = () => {
      const full_name = $('#download_full_name1').val();
      const email = $('#download_email1').val();
      const state = $('#download_state1').val();
      const isValidEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email);

      if (full_name && isValidEmail && state) {
        $('#download_book_Service1').prop('disabled', false);
      } else {
        $('#download_book_Service1').prop('disabled', true);
      }
    };

    validateForm();

    $("#download_full_name1, #download_email1, #download_state1").on('keyup change', validateForm);
  }

  getPdf = () => {
    $('#download_book_Service1').click((e) => {
      $('#download_book_Service1').attr('disabled', true);
      $('#download_book_Service1').text('Downloading...');
      const full_name = $('#download_full_name1').val();
      const email = $('#download_email1').val();
      const phone = $('#mobile_code2Form').val();
      const state = $('#download_state1').val();
      const vat_number = $('#main_vat2').val();
      const company = $('#main_company1').val();

      let isValid = true;
      if (!full_name) {
        isValid = false;
        $('.full_name1').show();
      } else {
        $('.full_name1').hide();
      }

      if (!email) {
        isValid = false;
        $('.email1').show();
      } else {
        $('.email1').hide();
      }

      if (!state) {
        isValid = false;
        $('.state1').show();
      } else {
        $('.state1').hide();
      }

      if (!phone) {
        isValid = false;
        $('.mobile_code2Form').show();
      } else {
        $('.mobile_code2Form').hide();
      }

     

      if (isValid) {
        $('.form-loading-overlay').addClass('showOverlay');

        fetch('/cart.js')
          .then(response => response.json())
          .then(cartData => {
            const dataToPost = {
              name: full_name,
              phone: phone,
              email: email,
              state: state,
              vat: vat_number,
              company: company,
              cart: cartData
            };

            return fetch('https://orangered-oryx-187562.hostingersite.com/test.php', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify(dataToPost),
            });
          })
          .then(response => {
            
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json(); // Assuming server returns { url: 'pdf-link' }
          })
          .then(data => {
            console.log('Success:', data.url); 
            window.open(`https://orangered-oryx-187562.hostingersite.com/test1.php?q=${data.url}`);
            $('#download_book_Service1').text('Downloaded');
            setTimeout(() => {
              $('#download_book_Service1').attr('disabled', false);
              $('#download_book_Service1').text('DOWNLOAD QUOTATION');
            }, 2000);
          })
          .catch(error => {
            console.error('Error:', error);
          })
          .finally(() => {
            $('.form-loading-overlay').removeClass('showOverlay');
          });
      }
    });
  }
  updateFreeShipping = () => {
    const eligibleAmt = parseInt(qs(".free-shipping").getAttribute("data-eligible-amt"));
    const cartTotal = parseInt(qs(".free-shipping").getAttribute("data-cart-total"));
    const difference = eligibleAmt - cartTotal;
    const progressBar = document.querySelector('.free-shipping-completed');

    if (cartTotal < eligibleAmt) {
      const percentage = (cartTotal / eligibleAmt) * 100;
      progressBar.style.width = `${percentage}%`;
      document.querySelector('.shipping.not-applied span').textContent = difference;
    } else {
      progressBar.style.width = '100%';
    }
  }
  insertState = () => {
    let DateInfo = getCookie("dateInfo");
    if (DateInfo && qs(".append_date")) {
      qsa(".append_date").forEach(element => {
        element.innerHTML = DateInfo;
      });
    }
    if (DateInfo && qs(".deliver-cart .append_date")) {
      qsa(".deliver-cart .append_date").forEach(element => {
        element.innerHTML = DateInfo.replace('’', '');
      });
    }
    let stateName = getCookie("state");
    if (stateName && qs(".append_country")) {
      qsa(".append_country").forEach(element => {
        element.textContent = stateName;
      });
    }
    fetch(window.stateFile)
      .then((response) => response.json())
      .then((data) => {
        var countryList = document.getElementById("countryList");

        data.forEach(function (block) {
          var radioButton = document.createElement("div");
          radioButton.classList.add("form-check", "country-list-check");
          radioButton.innerHTML = `
        <input class="form-check-input shipping_change_value" type="radio" name="flexRadioDefault"
          data-zone="${block.code}" data-name="${block.state}"
          id="${block.code}" value="${block.state}"
          data-date="${block.delivery_days}">
        <label class="form-check-label" for="${block.code}">${block.state}
        <i class="fa-solid fa-check city-check"></i></label>`;

          countryList && countryList.appendChild(radioButton);
        });
        if (stateName && qs(".append_country")) {
          qs('.shipping_change_value') && (qs(`.shipping_change_value[data-name="${stateName}"]`).checked = true);
        }
        this.getStateBasedOnIP();
        this.changeState();
        qs(".show-location-screen") && this.changeLocationClick();
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });

  };

  changeState = () => {
    let radioBtns = qsa(".shipping_change_value");
    radioBtns.forEach(function (radioBtn) {
      radioBtn.addEventListener("change", function () {
        if (this.checked) {
          const state = this.value;
          window.setCookie("state", state);
          qsa(".append_country").forEach(element => {
            element.textContent = state;
          });

          let today = new Date();
          let numberOfDaysToAdd = parseInt(this.getAttribute("data-date"));
          let newDateObject = new Date(today);

          let addedDays = 0;

          while (addedDays < numberOfDaysToAdd) {
              newDateObject.setDate(newDateObject.getDate() + 1);
              if (newDateObject.getDay() !== 0) {
                  addedDays++;
              }
          }

          let options = { month: "short", day: "2-digit", year: "2-digit" };
          let formattedNewDate = newDateObject.toLocaleDateString("en-US", options);
          formattedNewDate = formattedNewDate.replace(",", "");
          let dateParts = formattedNewDate.split(" ");

          let formattedDateString = `${dateParts[1]} ${dateParts[0]}’ ${dateParts[2]}`;
          window.setCookie("dateInfo", formattedDateString, 30);
          qsa(".append_date").forEach(element => {
            element.innerHTML = formattedDateString;
          });
          if (formattedDateString && qs(".deliver-cart .append_date")) {
            qsa(".deliver-cart .append_date").forEach(element => {
              element.innerHTML = formattedDateString.replace('’', '');
            });
          }
          let deliveryBlock = qs(".delivery-country-list-body");
          deliveryBlock.classList.remove("active");
          deliveryBlock.style.height = "auto";
          qs(".ship-close").style.display = "none";
          qs(".show-location-screen").style.display = "block";
          qs(".shop-cart-close").classList.remove("hide");
          qs(".drawer__inner").classList.remove("overflow-hidden");
        } else {

        }
      });
    });
  };

  getStateBasedOnIP = () => {
    async function fetchIpAddress() {
      const response = await fetch("https://api64.ipify.org?format=json");
      const data = await response.json();
      return data.ip;
    }

    async function fetchLocationInfo(ip) {
      const response = await fetch(`https://ipinfo.io/${ip}/json`);
      const data = await response.json();
      return data;
    }



    // Example usage:

    function getState(locationInfo) {
      const state = locationInfo.region;
      return { state };
    }

    fetchIpAddress()
      .then((ip) => fetchLocationInfo(ip))
      .then((locationInfo) => {
        let state = getCookie("state");
        if (!state) {
          state = locationInfo.region;
        }
        state && window.setCookie("state", state, 30);
        let formCheckInput = document.querySelector(`[data-name="${state}"]`);
        window.setCookie("state", state, 30);
        qs(".append_country") && (qs(".append_country").textContent = state);
        let today = new Date();
        if (formCheckInput) {
          let numberOfDaysToAdd = parseInt(
            formCheckInput.getAttribute("data-date")
          );
          let newDateObject = new Date(today);
          newDateObject.setDate(today.getDate() + numberOfDaysToAdd);

          let options = { month: "short", day: "2-digit", year: "2-digit" };
          let formattedNewDate = newDateObject.toLocaleDateString("en-US", options);
          formattedNewDate = formattedNewDate.replace(",", "");
          let dateParts = formattedNewDate.split(" ");

          let formattedDateString = `${dateParts[1]} ${dateParts[0]}’ ${dateParts[2]}`;
          window.setCookie("dateInfo", formattedDateString, 30);
          qsa(".append_date").forEach(element => {
            element.innerHTML = formattedDateString;
          });
          if (formattedDateString && qs(".deliver-cart .append_date")) {
            qsa(".deliver-cart .append_date").forEach(element => {
              element.innerHTML = formattedDateString.replace('’', '');
            });
          }
          qsa(".append_country").forEach(element => {
            element.textContent = state;
          });
          formCheckInput.checked = true;
        }
      })
      .catch((error) => {
        console.error("Error fetching IP address:", error);
      });
  };

  changeLocationClick = () => {
    let changeLocationButton = qs(".change-location");
    let changeLoc = qs(".show-location-screen");
    let cartDrawer = qs(".drawer");
    let deliveryBlock = qs(".delivery-country-list-body");
    if (changeLoc) {
      changeLoc.addEventListener("click", function () {
        qs(".shop-cart-close").classList.add("hide");
        qs(".drawer__inner").classList.add("overflow-hidden");
        deliveryBlock.classList.add("active");
        document.body.classList.add("overflow-hidden");
        setTimeout(() => {
          cartDrawer.classList.add("animate", "active");
        });
        deliveryBlock.style.height = "100vh";
        qs(".ship-close").style.display = "block";
        qs(".show-location-screen") && (qs(".show-location-screen").style.display = "none");
        deliveryBlock.classList.add("active");
      });
    }
    if (changeLocationButton) {
      changeLocationButton.addEventListener("click", function () {
        if (qs(".cart__empty-text")) {
          qs('.unable-to-click') && qs('.unable-to-click').classList.remove('hide');
          return;
        }
        else {
          qs('.unable-to-click') && qs('.unable-to-click').classList.add('hide');
          if (deliveryBlock) {
            deliveryBlock.classList.add("active");
            document.body.classList.add("overflow-hidden");
            deliveryBlock.style.height = "100%";
            qs(".show-location-screen") && (qs(".show-location-screen").style.display = "none");
            setTimeout(() => {
              cartDrawer.classList.add("animate", "active");
            });
          }
        }
      });
    }

    if (qs(".ship-close")) {
      qs(".ship-close").addEventListener(
        "click",
        function (event) {
          qs(".shop-cart-close").classList.remove("hide");
          qs(".drawer__inner").classList.remove("overflow-hidden");
          qs(".ship-close").style.display = "none";
          document.body.classList.remove("overflow-hidden");
          let deliveryBlock = qs(".delivery-country-list-body");
          deliveryBlock.classList.remove("active");
          changeLocationButton && (changeLocationButton.style.display = 'block');
          qs(".show-location-screen").style.display = 'block';
        }
      );
    }
  };

  slideShow = () => {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('.cart-drawer .swiper-container').forEach((container) => {
      const slides = container.querySelectorAll('.swiper-slide');

      if (slides.length < 2) return;
      if (container.swiper && !container.swiper.destroyed) {
        container.swiper.update();
        return;
      }

      const nextEl = container.querySelector('.swiper-button-next');
      const prevEl = container.querySelector('.swiper-button-prev');

      new Swiper(container, {
        slidesPerView: 2,
        spaceBetween: 10,
        navigation: nextEl && prevEl ? { nextEl, prevEl } : undefined,
        loop: slides.length > 2,
        watchOverflow: true,
        arrows: true,
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
        },
      });
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
